<template>
<div class="question-editor-tab-form">
    <div class="label">
        {{trans.edit_form.question_type_label }}
        <span>{{ trans.edit_form.question_types[question.type] }}</span>
    </div>
    <div class="label">
        {{ trans.edit_form.question_tabs.question_full_text_label }}
    </div>
    <question-tinymce-editor
        :question="question"
        :disabled="!isCanEdit"
    ></question-tinymce-editor>
    <template v-if="!question.is_without_answers">
        <div class="label answer-section-label">
            {{ trans.edit_form.question_tabs.question_answers_section_label }}
        </div>
        <question-edit-answer-options-table
            :question="question"
            :disabled="!isCanEdit"
        />
        <create-button
            class="card test-card add-test-question-answer-card"
            :is-disabled="!isCanEdit"
            :is-in-progress="false"
            :click-handler="addAnswerClickHandler"
        />
    </template>
    <p v-else class="help mt-1">{{ trans.edit_form.cannot_has_variants }}</p>

    <p v-if="textError" class="help is-danger mt-1">{{textError}}</p>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import QuestionTinymceEditor from "../QuestionTinymceEditor";
import QuestionEditAnswerOptionsTable from "../answers/QuestionEditAnswerOptionsTable";
import CreateButton from "../../../../../utils/CreateButton";
import TEST_QUESTION_TYPES from "../../../../../../const/test-question-types";

export default {
    name: "QuestionEditorTabForm",
    components: {QuestionEditAnswerOptionsTable, QuestionTinymceEditor, CreateButton},
    props: {
        question: Object,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testBeingEdited',
            'testEditor',
            'isCanEdit',
        ]),
        textError() {
            try {
                return this.testEditor.errors[this.question.hash_id]['answers'][0];
            } catch {}
        },
    },
    mounted() {
        if (this.question.hasOwnProperty('answers')) {
            if (Object.keys(this.question.answers).length) {
                return;
            }
        }

        // Если у вопроса совсем нет ответов, то добавим пустой
        if (this.question.is_required_answers) {
            this.addNewAnswer();
        }
    },
    methods: {
        ...mapActions('tests', [
            'addAnswer',
            'clearTestQuestionError',
        ]),
        addAnswerClickHandler(e) {
            this.clearErrors();
            this.addNewAnswer();
        },
        addNewAnswer(quantity = 1) {
            while (quantity > 0) {
                this.addAnswer(this.question.hash_id);
                quantity--;
            }
        },
        clearErrors() {
            this.clearTestQuestionError(this.question.hash_id)
        },
    }

}
</script>

<style lang="scss" scoped>
.add-test-question-answer-card {
    height: 55px !important;
    border: none !important;
}

.question-editor-tab-form {
    .label {
        margin-bottom: 20px;

        &.answer-section-label {
            margin-bottom: 0;
        }

        &:not(:first-child) {
            margin-top: 20px;
        }
    }
}
</style>

<style lang="scss">
.question-editor-tab-form {
    .tox {
        &.tox-tinymce {
            border-radius: 6px;
            border: none;
        }

        .tox-toolbar__group {
            border-right-color: #000;
            margin-top: 1.5px;
        }

        .tox-tbtn {
            width: 30px;
            height: 30px;
        }

        .tox-split-button__chevron {
            width: 16px;
        }
    }
}
</style>
